import imgPlaceholder from '../assets//img/img-placeholder.png'
import { COLORS } from './constants'
import moment from 'moment';


export const addClassToBody = () => document.querySelector("body").className = "sign-page";


export const convertByTimeZone = (time, isZone) => {

    const HOURS = [
        { key: "01:00", value: 1 },
        { key: "02:00", value: 2 },
        { key: "03:00", value: 3 },
        { key: "04:00", value: 4 },
        { key: "05:00", value: 5 },
        { key: "06:00", value: 6 },
        { key: "07:00", value: 7 },
        { key: "08:00", value: 8 },
        { key: "09:00", value: 9 },
        { key: "10:00", value: 10 },
        { key: "11:00", value: 11 },
        { key: "12:00", value: 12 },
        { key: "13:00", value: 13 },
        { key: "14:00", value: 14 },
        { key: "15:00", value: 15 },
        { key: "16:00", value: 16 },
        { key: "17:00", value: 17 },
        { key: "18:00", value: 18 },
        { key: "19:00", value: 19 },
        { key: "20:00", value: 20 },
        { key: "21:00", value: 21 },
        { key: "22:00", value: 22 },
        { key: "23:00", value: 23 },
        { key: "00:00", value: 24 }
    ];
    const hourVal = HOURS.find(hour => hour.key === time);
   const hrs = -(new Date().getTimezoneOffset() / 60);
    let convertedTime;
   if(isZone) {
       convertedTime = hourVal.value + hrs;
   } else {
       convertedTime = hourVal.value - hrs;
   }

    if(convertedTime > 24) {
        convertedTime = convertedTime - 24;
    } else if(convertedTime < 0) {
        convertedTime = 24 + convertedTime;
    } else if(convertedTime === 0) {
        convertedTime = 24;
    }

    convertedTime = HOURS.find(hour => hour.value === convertedTime);
   return convertedTime.key;
};

export const RemoveClassFromBody = () => document.querySelector("body").classList.remove("sign-page");

export const modifyAuthError = error => {
    const message = error.response.data.errors[0].message;
    return {[message === 'Email does not exists.' ? 'email' : 'password']: message};
};

export const getColorName = colorKey => {
    let colorName;
    for(let i = 0; i < COLORS.length; i++) {
        if (COLORS[i].value === colorKey) {
            colorName = COLORS[i].key;
            break;
        }
    }

    return colorName;

};


export const modifyDriver = driver => {
    return {
        image: driver.image ? driver.image : imgPlaceholder,
        status: driver.is_active ? 'Active' : 'Inactive',
        id: driver.id,
        firstName: driver.first_name,
        lastName: driver.last_name,
        driverIqamaSaudiId: driver.driver_iqama_saudi_id,
        mobileNumber: driver.mobile_number,
        email: driver.email,
        agreedDeposit: driver.agreed_deposit,
        transportYear: driver.transport_year,
        transportModel: driver.transport_model,
        licensePlate: driver.license_plate,
        transportColor: driver.transport_color,
        workType: driver.work_type,
        agreedFixedSalary: driver.agreed_fixed_salary,
        zone: driver.zone,
        transportType: driver.transport_type
    }
};




// WEBPACK FOOTER //
// ./src/utils/utils.js